const NAVBAR_HEIGHT = 60
const PRODUCTSIDEBAR_VERTICAL_MARGIN = 15;
const PRODUCTSIDEBAR_TOP_OFFSET = -15;

st.ProductView = class ProductView {
  constructor() {
    this.$header = $(".product-view-header");
    this.$content = $(".product-view-content");
    this.$sidebar = $(".productsidebar");

    this.onResize();
    $(window).resize(() => this.onResize());
    setInterval((() => this.onResize()), 300);

    this.onScroll();
    $(window).scroll(() => this.onScroll());
  }

  onResize() {
    if (!st.Media.isMax("sm")) {
      this.$content.css("min-height", (this.$sidebar.height() - this.$header.height()) + (PRODUCTSIDEBAR_VERTICAL_MARGIN * 3));
      this.MIN_SCROLL = (this.$header.offset().top + PRODUCTSIDEBAR_TOP_OFFSET) - (NAVBAR_HEIGHT + PRODUCTSIDEBAR_VERTICAL_MARGIN);
      this.MAX_SCROLL = (this.$content.offset().top + this.$content.height()) - this.$sidebar.height() - PRODUCTSIDEBAR_TOP_OFFSET - NAVBAR_HEIGHT - (PRODUCTSIDEBAR_VERTICAL_MARGIN * 5);
    } else {
      this.$content.css("min-height", "");
    }
    return this.onScroll();
  }

  onScroll() {
    if (st.Media.isMax("sm") || window.scrollY <= this.MIN_SCROLL || this.MIN_SCROLL >= this.MAX_SCROLL) {
      this.$sidebar.toggleClass("sticky", false);
      return this.$sidebar.attr("style", "");
    } else if (window.scrollY <= this.MAX_SCROLL) {
      this.$sidebar.toggleClass("sticky", true);
      this.$sidebar.attr("style", "");
      this.$sidebar.css("left", this.$sidebar.closest(".column-side").offset().left);
      return this.$sidebar.css("width", this.$sidebar.closest(".column-side").width() + (2 * 15));
    } else {
      this.$sidebar.toggleClass("sticky", false);
      this.$sidebar.attr("style", "");
      return this.$sidebar.css("top", (this.$header.height() + this.$content.height()) - this.$sidebar.height() - (PRODUCTSIDEBAR_VERTICAL_MARGIN * 3));
    }
  }
};


$(document).ready(function() {
  if ($(".product-view").length > 0) {
    return window.productView = new st.ProductView;
  }
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/product_view.js